import styled from 'styled-components'

export const ScrollHeightBaseWrapper = styled.div`
  height: ${props => props.height || '160px'};
  padding: ${props => props.padding || '0'};

  .rcs-inner-handle {
    background: #cccccc;
  }
`